import React from 'react';
import { Chip, Tooltip } from '@mui/material';

// free payment made by an admin on manual close-out, not by the user
export const isAdminPayment = (payment) => !!payment?.byAdmin;

export const paymentAdminLabel = (payment) =>
    payment.byAdmin.name || payment.byAdmin.email || `#${payment.byAdmin.id}`;

export const adminPaymentDescription = (payment) =>
    `Nem a felhasználó fizette: ${paymentAdminLabel(
        payment
    )} ingyenesen kifizette a parkoló rendszerben a parkolás kézi lezárásakor (az összeg elengedve).`;

// SimplePay transaction statuses (+ STARTED: created by us, SimplePay has not answered yet)
export const PAYMENT_STATUS_LABELS = Object.freeze({
    STARTED: 'Elindítva',
    INIT: 'Elindítva',
    INPAYMENT: 'Fizetés folyamatban',
    AUTHORIZED: 'Engedélyezve',
    INFRAUD: 'Ellenőrzés alatt',
    FINISHED: 'Sikeres',
    TIMEOUT: 'Időtúllépés',
    CANCELLED: 'Megszakítva',
    NOTAUTHORIZED: 'Nem engedélyezett',
    FRAUD: 'Csalásgyanú',
    REVERSED: 'Visszavonva',
    REFUND: 'Visszatérítve',
});

const FAILED_STATUSES = ['TIMEOUT', 'CANCELLED', 'NOTAUTHORIZED', 'FRAUD', 'REVERSED', 'REFUND'];

export const paymentStatusLabel = (status) => PAYMENT_STATUS_LABELS[status] || status || '–';

const paymentStatusColor = (status) => {
    if (status === 'FINISHED') return 'success';
    if (FAILED_STATUSES.includes(status)) return 'error';
    return 'info';
};

// every non-admin payment was started by the guest in the app (SimplePay)
export function PaymentStatus({ payment, size = 'small' }) {
    if (!isAdminPayment(payment)) {
        return (
            <Tooltip title={`Az appban indított SimplePay fizetés, állapot: ${payment.status}`}>
                <Chip
                    size={size}
                    variant={payment.status === 'FINISHED' ? 'filled' : 'outlined'}
                    color={paymentStatusColor(payment.status)}
                    label={`App – ${paymentStatusLabel(payment.status)}`}
                />
            </Tooltip>
        );
    }
    return (
        <Tooltip title={adminPaymentDescription(payment)}>
            <Chip size={size} color="warning" label={`Admin – ${paymentAdminLabel(payment)}`} />
        </Tooltip>
    );
}

export const paymentAmountLabel = (payment, amount = payment.amount) =>
    isAdminPayment(payment) ? `${amount} (elengedve)` : amount;
